module.exports = __webpack_public_path__ + "static/media/pantalla-recuperoclave.568f143d.jpg";